import React, { useMemo, useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Box,
    IconButton,
} from "@mui/material";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { sectionOrder, transformPeriodData } from "./mapper";

// dayjs.extend(advancedFormat);
// dayjs.extend(customParseFormat);

// const formatPeriod = (value, viewType) => {
//     if (!value) return "-";

//     switch (viewType) {
//         case "monthly":
//             return dayjs(value, "MM-YYYY").format("MMM YYYY");

//         case "daily":
//             return dayjs(value, "DD-MM-YYYY").format("Do MMM YYYY");

//         case "weekly": {
//             const [start, end] = value.split(" to ");

//             const startDate = dayjs(start, "DD-MM-YYYY").format("Do MMM");
//             const endDate = dayjs(end, "DD-MM-YYYY").format("Do MMM");

//             return `${startDate} to ${endDate}`;
//         }

//         default:
//             return value;
//     }
// };

// const sectionOrder = [
//     "Safe Manhours",
//     "Training",
//     "Safety Meeting",
//     "Reward & Recognition",
//     "Monitoring & Measurement",
//     "Finding Tracker",
//     "Environment Reporting",
//     "Safety Resources",
// ];

// const transformPeriodData = (data = [], viewType) => {

//     const periodSet = new Set();
//     const grouped = {};

//     data.forEach((item) => {

//         const period = formatPeriod(item.period, viewType);

//         periodSet.add(period);

//         if (!grouped[item.section]) {
//             grouped[item.section] = {};
//         }

//         if (!grouped[item.section][item.description]) {
//             grouped[item.section][item.description] = {};
//         }

//         grouped[item.section][item.description][period] = item.value;
//     });

//     const periods = Array.from(periodSet);

//     return { grouped, periods };
// };

// const monthWidth = 160;
// const sectionWidth = 220;
// const descriptionWidth = 320;
const sectionWidth = 150;
const descriptionWidth = 300;
const monthWidth = 90;
const valueWidth = 120;

const HSEMonthViewDataTable = ({ apiData = [], isFetching, viewTypeValue }) => {

    const hasData = Array.isArray(apiData) && apiData.length > 0;
    const viewLabel = viewTypeValue === 'monthly' ? "Month" : viewTypeValue === 'weekly' ? "Week" : "Day";

    const flattenedData = apiData.flatMap((row) =>
        row?.data?.map((item) => ({
            period: item.period,
            value: item.value,
            section: row.section,
            description: row.description,
        })) || []
    );

    const sortedData = [...flattenedData].sort((a, b) => {
        if (a.period !== b.period) return a.period.localeCompare(b.period);
        if (a.section !== b.section) return a.section.localeCompare(b.section);
        return a.description.localeCompare(b.description);
    });

    const { grouped, periods } = useMemo(() => {
        return transformPeriodData(sortedData, viewTypeValue);
    }, [sortedData, viewTypeValue]);

    console.log("hse type", apiData, flattenedData, periods, grouped, viewTypeValue, Object.entries(grouped))

    // const periodCounts = {};
    // sortedData.forEach((item) => {
    //     periodCounts[item.period] = (periodCounts[item.period] || 0) + 1;
    // });

    // const renderedPeriods = {};

    if (isFetching) {
        return (
            <Box sx={{ textAlign: "center", py: 5 }}>
                <Typography>Loading...</Typography>
            </Box>
        );
    }

    return (
        <TableContainer component={Paper} sx={{ maxHeight: 650, overflowX: "auto" }}>
            <Table
                size="small"
                stickyHeader
                sx={{
                    minWidth:
                        monthWidth + sectionWidth + descriptionWidth + valueWidth,
                    borderCollapse: "separate",
                    borderSpacing: 0,
                }}
            >

                {/* <TableHead
                    sx={{
                        "& .MuiTableCell-root": {
                            py: 2,
                        },
                    }}
                >
                    <TableRow>

                        <TableCell
                            align="center"
                            sx={{
                                width: monthWidth,
                                minWidth: monthWidth,
                                position: "sticky",
                                left: 0,
                                zIndex: 4,
                                backgroundColor: "#F9FAFB",
                                border: "1px solid #e0e0e0",
                                fontWeight: "bold",
                            }}
                        >
                            {viewLabel}
                        </TableCell>

                        <TableCell
                            align="center"
                            sx={{
                                width: sectionWidth,
                                minWidth: sectionWidth,
                                border: "1px solid #e0e0e0",
                                backgroundColor: "#F9FAFB",
                                fontWeight: "bold",
                            }}
                        >
                            Section
                        </TableCell>

                        <TableCell
                            align="center"
                            sx={{
                                width: descriptionWidth,
                                minWidth: descriptionWidth,
                                border: "1px solid #e0e0e0",
                                backgroundColor: "#F9FAFB",
                                fontWeight: "bold",
                            }}
                        >
                            Description
                        </TableCell>

                        <TableCell
                            align="center"
                            sx={{
                                width: valueWidth,
                                minWidth: valueWidth,
                                border: "1px solid #e0e0e0",
                                backgroundColor: "#F9FAFB",
                                fontWeight: "bold",
                            }}
                        >
                            Value
                        </TableCell>

                    </TableRow>
                </TableHead> */}
                <TableHead>
                    <TableRow>

                        <TableCell
                            sx={{
                                width: sectionWidth,
                                position: "sticky",
                                left: 0,
                                zIndex: 4,
                                backgroundColor: "#F9FAFB",
                                border: "1px solid #e0e0e0",
                                fontWeight: "bold",
                            }}
                        >
                            Section
                        </TableCell>

                        <TableCell
                            sx={{
                                width: descriptionWidth,
                                position: "sticky",
                                left: sectionWidth,
                                zIndex: 3,
                                backgroundColor: "#F9FAFB",
                                border: "1px solid #e0e0e0",
                                fontWeight: "bold",
                            }}
                        >
                            Description
                        </TableCell>

                        {periods.map((period) => (
                            <TableCell
                                key={period}
                                align="center"
                                sx={{
                                    width: monthWidth,
                                    border: "1px solid #e0e0e0",
                                    backgroundColor: "#F9FAFB",
                                    fontWeight: "bold",
                                }}
                            >
                                {period}
                            </TableCell>
                        ))}

                        <TableCell
                            align="center"
                            sx={{
                                width: valueWidth,
                                border: "1px solid #e0e0e0",
                                backgroundColor: "#F9FAFB",
                                fontWeight: "bold",
                            }}
                        >
                            Total
                        </TableCell>

                    </TableRow>
                </TableHead>

                <TableBody>

                    {!hasData ? (
                        <TableRow>
                            <TableCell
                                colSpan={4}
                                align="center"
                                sx={{
                                    py: 5,
                                    border: "1px solid #e0e0e0",
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: "16px",
                                        fontWeight: 500,
                                        color: "#6B7280",
                                    }}
                                >
                                    No Records Found
                                </Typography>
                            </TableCell>
                        </TableRow>
                    ) : (

                        sectionOrder
                            .filter(section => grouped[section])
                            .map((section) => {
                                const descriptions = grouped[section];
                                const descEntries = Object.entries(descriptions);

                                return descEntries.map(([description, values], index) => {
                                    console.log("des", description, values)

                                    const total = periods.reduce(
                                        (sum, prev) => sum + (values[prev] || 0),
                                        0
                                    );
                                    const roundedTotalValue = total.toFixed(2);

                                    return (
                                        <TableRow key={section + description}>

                                            {index === 0 && (
                                                <TableCell
                                                    rowSpan={descEntries.length}
                                                    sx={{
                                                        position: "sticky",
                                                        left: 0,
                                                        zIndex: 2,
                                                        backgroundColor: "#F9FAFB",
                                                        border: "1px solid #e0e0e0",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    {section}
                                                </TableCell>
                                            )}

                                            <TableCell
                                                sx={{
                                                    position: "sticky",
                                                    left: sectionWidth,
                                                    backgroundColor: "#fff",
                                                    border: "1px solid #e0e0e0",
                                                }}
                                            >
                                                {description}
                                            </TableCell>

                                            {periods.map((period) => (
                                                <TableCell
                                                    key={period}
                                                    align="center"
                                                    sx={{ border: "1px solid #e0e0e0" }}
                                                >
                                                    {values[period] ?? 0}
                                                </TableCell>
                                            ))}

                                            <TableCell
                                                align="center"
                                                sx={{
                                                    border: "1px solid #e0e0e0",
                                                    fontWeight: "bold",
                                                    backgroundColor: "#F9FAFB",
                                                }}
                                            >
                                                {roundedTotalValue || 0}
                                            </TableCell>

                                        </TableRow>
                                    );
                                });
                            }))}
                </TableBody>
                {/* <TableBody>

                    {sectionOrder
                        .filter(section => grouped[section])
                        .map((section) => {
                            const descriptions = grouped[section];
                            const descEntries = Object.entries(descriptions);

                            return descEntries.map(([description, values], index) => {
                                console.log("des", description, values)

                                const total = periods.reduce(
                                    (sum, prev) => sum + (values[prev] || 0),
                                    0
                                );
                                const roundedTotalValue = total.toFixed(2);

                                return (
                                    <TableRow key={section + description}>

                                        {index === 0 && (
                                            <TableCell
                                                rowSpan={descEntries.length}
                                                sx={{
                                                    position: "sticky",
                                                    left: 0,
                                                    zIndex: 2,
                                                    backgroundColor: "#F9FAFB",
                                                    border: "1px solid #e0e0e0",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                {section}
                                            </TableCell>
                                        )}

                                        <TableCell
                                            sx={{
                                                position: "sticky",
                                                left: sectionWidth,
                                                backgroundColor: "#fff",
                                                border: "1px solid #e0e0e0",
                                            }}
                                        >
                                            {description}
                                        </TableCell>

                                        {periods.map((period) => (
                                            <TableCell
                                                key={period}
                                                align="center"
                                                sx={{ border: "1px solid #e0e0e0" }}
                                            >
                                                {values[period] ?? "-"}
                                            </TableCell>
                                        ))}

                                        <TableCell
                                            align="center"
                                            sx={{
                                                border: "1px solid #e0e0e0",
                                                fontWeight: "bold",
                                                backgroundColor: "#F9FAFB",
                                            }}
                                        >
                                            {roundedTotalValue || "-"}
                                        </TableCell>

                                    </TableRow>
                                );
                            });
                        })}

                </TableBody> */}
            </Table>
        </TableContainer>
    );
};

export default HSEMonthViewDataTable;